<template>
  <div class="stadyList">
    <div class="disFlex">
      <div class="flex1 stadyBlok" style="background-color: #0071BA;">
        <div class="kuaiStady">
          <div class="stadyName">今日学习时长</div>
          <div><span class="stadyNum">{{tjData.daytime?tjData.daytime:0}}</span>分钟</div>
        </div>
      </div>
      <div class="flex1 stadyBlok">
        <div class="kuaiStady">
          <div class="stadyName">累计学习时长</div>
          <div><span class="stadyNum">{{tjData.ljalltime?tjData.ljalltime:0}}</span>分钟</div>
        </div>
      </div>
      <div class="flex1 stadyBlok" style="background-color: #FF9926;">
        <div class="kuaiStady">
          <div class="stadyName">累计学习课程数</div>
          <div><span class="stadyNum">{{tjData.allcurr?tjData.allcurr:0}}</span>节</div>
        </div>
      </div>
      <div class="flex1 stadyBlok" style="margin-right: 0px;background-color: #FF6666;">
        <div class="kuaiStady">
          <div class="stadyName">整体完成率</div>
          <div><span class="stadyNum">{{tjData.allpercent?tjData.allpercent:0}}</span>%</div>
        </div>
      </div>
    </div>
    <div style="height: 36px;text-align: right;margin:20px 0 20px 0;">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.itype" placeholder="请选择全部课程类别" clearable>
            <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text" style="width: 100%;">
              <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                :value="item.uniqueCode">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="width: 130px;">
          <el-select v-model="formInline.learnstate" placeholder="学习状态" clearable>
            <el-option label="未开始" value="-1"></el-option>
            <el-option label="学习中" value="0"></el-option>
            <el-option label="已学完" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="width: 130px;">
          <el-select v-model="formInline.kstate" placeholder="考试状态" clearable>
            <el-option label="通过" value="1"></el-option>
            <el-option label="未通过" value="0"></el-option>
            <el-option label="未考试" value="-1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData.rows" style="width: 100%" max-height="250">
      <el-table-column prop="date" label="封面">
        <template slot-scope="scope">
          <img :src="wjSrc+scope.row.img" style="width: 52px;height: 31px;border-radius: 3px;" />
        </template>
      </el-table-column>
      <el-table-column prop="cname" label="名称">
      </el-table-column>
      <el-table-column prop="itypeName" label="课程类别">
      </el-table-column>
      <el-table-column prop="learnstate" label="学习状态" width="295">
        <template slot-scope="scope">
          <div class="learnstateDiv" @click="toMx(scope.row.id)">
            <div class="progressL">
              <div :style="'width:'+scope.row.percent+'%'"></div>
            </div>
            <div class="disFlex between">
              <div>已学：<span style="color: #0071BA;">{{scope.row.ids}}</span>/{{scope.row.id1s}}</div>
              <div>学习总时长：{{scope.row.allTime}}分钟</div>
              <div>{{scope.row.percent}}%</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="startime" label="考试时间" width="150">
      </el-table-column>
      <el-table-column prop="fraction" label="考试分数">
      </el-table-column>
      <el-table-column prop="kstate" label="考试结果">
        <template slot-scope="scope">
          <span v-if="scope.row.kstate=='1'" style="color: #00BC68;">已通过</span>
          <span v-if="scope.row.kstate=='-1'" style="color: #0071BA;">未考试</span>
          <span v-if="scope.row.kstate=='0'" style="color: #D50000;">未通过</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
      :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
    </el-pagination>
  </div>
</template>
<script>
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    name: 'StadyList',
    props: ['creator', 'wjSrc'],
    data() {
      return {
        formInline: {
          kstate: '',
          itype: '',
          learnstate: '',
          rows: 10,
          page: 1,
          creator: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        options: [],
        tjData: {}
      }
    },
    methods: {
      getList: function(id) {
        if (this.formInline.creator) {
          this.$axios.get('/kt/learnfile/getlistPage.htm?' + this.$qs.stringify(this.formInline)).then(res => {
            var data = res.data;
            this.tableData = data;
          })
        }
      },
      getTjdata: function() {
        this.$axios.get('/kt/learnfile/getLearntime.htm?creator=' + this.creator).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.tjData = data.data;
          } else {
            // this.$message.error(data.message);
          }
        })
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      toMx: function(id) {
        this.$router.push('/Company/stadyList?id=' + id+'&creator='+this.formInline.creator);
      }
    },
    created: function() {
      getItype(this.$axios, ((res) => {
        this.options = res;
      }));
      this.$set(this.formInline, 'creator', this.creator);
      this.getTjdata(); //统计数据
    },
    mounted: function() {},
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getList();
        },
        deep: true //true 深度监听
      },
      creator: {
        handler(val, oldVal) {
          this.$set(this.formInline, 'creator', val);
          this.getTjdata(); //统计数据
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .stadyBlok {
    height: 118px;
    opacity: 1;
    margin-right: 20px;
    background: #00bc68;
    border-radius: 4px;
  }

  .kuaiStady {
    background-color: #fff;
    height: 107px;
    margin-top: 11px;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    padding: 0 20px;
  }

  .stadyName {
    height: 22px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
  }

  .stadyNum {
    height: 38px;
    opacity: 1;
    font-size: 30px;
    font-family: 'HelveticaNeue';
    text-align: left;
    color: rgba(0, 0, 0, 0.85);
    line-height: 38px;
  }

  .stadyList .el-table th {
    background-color: #EFEFEF;
  }

  .learnstateDiv {
    width: 284px;
  }

  .progressL {
    width: 284px;
    height: 6px;
    opacity: 1;
    background: #f5f5f5;
    border-radius: 8px;
    margin-bottom: 11px;
  }

  .progressL div {
    height: 6px;
    opacity: 1;
    background: #0071ba;
    border-radius: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/StadyList.vue